"use strict";

var _react = _interopRequireDefault(require("react"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var _default = function _default(a) {
  var b,
      c = a.pagination,
      d = a.activePage,
      e = a.firstPageCssClass,
      f = c.pages,
      g = c.type;
  return "percentage" === g ? b = "".concat(100 / f.length * d, "%") : "steps" === g ? b = f.join(" ") : void 0, _react["default"].createElement("div", null, "percentage" === g && "progress-bar" === e ? _react["default"].createElement("progress", {
    max: "100",
    value: 100 / f.length * d
  }) : b);
};

exports["default"] = _default;